import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { GraphQLClient } from '../shared/services/graph-qlclient.service';
@Injectable({
  providedIn: 'root'
})
export class ProtestoChequeService {

  constructor(
    private gqlclient: GraphQLClient
  ) { }

  obtenerSegunFiltro(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($entidad: protesto_chequeInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
          protesto_cheque {
            obtenerSegunFiltro(filtro: {exacto: $entidad}, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  codigo
                  deposito_documento_codigo
                  motivo
                  fecha_protesto
                  monto
                  fecha_registro
                  cliente_proveedor_rut
                  empresa_rut
                  sucursal_codigo
                  rut_usuario
                  cliente_proveedor_nombre
                  nombre_usuario
                  numero_doc
                  banco_codigo
                  nombre_banco
                }
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.protesto_cheque.obtenerSegunFiltro
        callback({ mensajes, respuesta })
      }
    );
  }

  obtenerTodosProtesto(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($entidad: protesto_chequeInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
          protesto_cheque {
            obtenerTodosProtesto(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  codigo
                  deposito_documento_codigo
                  motivo
                  fecha_protesto
                  monto
                  fecha_registro
                  cliente_proveedor_rut
                  empresa_rut
                  sucursal_codigo
                  rut_usuario
                  cliente_proveedor_nombre
                  nombre_usuario
                  numero_doc
                  banco_codigo
                  nombre_banco
                }
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.protesto_cheque.obtenerTodosProtesto
        callback({ mensajes, respuesta })
      }
    );
  }

  obtenerExcel(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($entidad: protesto_chequeInputType) {
          protesto_cheque {
            obtenerExcel(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                rutaArchivo
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.protesto_cheque.obtenerExcel
        callback({ mensajes, respuesta })
      }
    );
  }

  obtenerProtestoSegunCodigo(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($entidad: protesto_chequeInputType) {
          protesto_cheque {
            obtenerProtestoSegunCodigo(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                codigo
                deposito_documento_codigo
                motivo
                fecha_protesto
                monto
                fecha_registro
                cliente_proveedor_rut
                empresa_rut
                sucursal_codigo
                rut_usuario
                cliente_proveedor_nombre
                nombre_usuario
                numero_doc
                banco_codigo
                nombre_banco
                numero_cuenta
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.protesto_cheque.obtenerProtestoSegunCodigo
        callback({ mensajes, respuesta })
      }
    );
  }

  guardarProtesto(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        mutation ($entidad: protesto_chequeInputType) {
          protesto_cheque {
            guardarProtesto(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                codigo
                deposito_documento_codigo
                motivo
                fecha_protesto
                monto
                fecha_registro
                cliente_proveedor_rut
                empresa_rut
                sucursal_codigo
                rut_usuario
                banco_codigo
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.protesto_cheque.guardarProtesto
        callback({ mensajes, respuesta })
      }
    );
  }

  obtenerPortestoParaRedeposito(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($entidad: protesto_chequeInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
          protesto_cheque {
            obtenerPortestoParaRedeposito(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  numero_doc
                  codigo
                  deposito_documento_codigo
                  motivo
                  fecha_protesto
                  monto
                  fecha_registro
                  cliente_proveedor_rut
                  empresa_rut
                  sucursal_codigo
                  rut_usuario
                  cliente_proveedor_nombre
                  nombre_usuario
                  pago_codigo
                  banco_codigo
                  nombre_banco
                }
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.protesto_cheque.obtenerPortestoParaRedeposito
        callback({ mensajes, respuesta })
      }
    );
  }
}
